import moment from "moment";

export default {
    props: {
    therm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      gal_h: null,
      nome: null,
      position: null,
      phoneEnabled: false,
      pushEnabled: false,
      dialogDeleteRecords: false,
      dialogDeleteTherm: false,
      deleteOption: 30,
    };
  },
  watch: {
    position(newVal) {
      if (newVal < 0) this.position = 0;
      if (newVal > this.$store.getters.get_therm.length - 1)
        this.position = this.$store.getters.get_therm.length - 1;
    },
  },
  methods: {
    open() {
      this.dialog = true;
      this.gal_h = this.therm.lit_h || 0;
      this.nome = this.therm.nome || "";
      this.position = this.therm.position || 0;
      this.phoneEnabled = this.therm.phoneEnabled || false;
      this.pushEnabled = this.therm.pushEnabled || false;
    },
    save() {
      this.changeThermSettings();
      this.dialog = false;
    },
    changePosition() {
      this.$store.dispatch("changeThermPosition", {
        sid: this.therm.sid,
        newPos: this.therm.position,
      });
    },
    changeThermSettings() {
      this.$store.dispatch("changeThermSettings", {
        sid: this.therm.sid,
        settings: {
          lit_h: this.gal_h,
          nome: this.nome,
          position: this.position,
          phoneEnabled: this.phoneEnabled,
          pushEnabled: this.pushEnabled,
        },
      });
    },
    eliminaRecords() {
      this.$store.dispatch("deleteThermRecords", {
        sid: this.therm.sid,
        ts_fine: moment()
          .subtract(this.deleteOption, "days")
          .endOf("day")
          .unix(),
      });
      this.dialogDeleteRecords = false;
    },
    eliminaThermostat() {
      this.$store.dispatch("deleteThermostat", {
        sid: this.therm.sid,
      });
      this.dialogDeleteTherm = false;
      this.dialog = false;
    },
  },
};